import {
    Component,
    OnInit,
    OnDestroy,
    Renderer2,
  } from '@angular/core';
  import { Location } from '@angular/common';
  import * as AOS from 'aos';
  import { Meta } from '@angular/platform-browser';
  
  @Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
  })
  export class AppComponent implements OnInit, OnDestroy {
    private scrollListener: () => void;
    private splineInterval: any;
  
    constructor(
      private renderer: Renderer2,
      public location: Location,
      private metaTagService: Meta,
    ) {}
  
    ngOnInit(): void {
      AOS.init();
      this.setMetaTags();
      this.scrollToTop();
      this.bindScrollEffect();
      this.hideSplineLogo();
  
      const inactiveBtn = document.getElementById('inactive');
      if (inactiveBtn) {
        inactiveBtn.addEventListener('click', () => {
          inactiveBtn.classList.remove('active');
          inactiveBtn.classList.add('active');
        });
      }
    }
  
   
  
    ngOnDestroy(): void {
      if (this.scrollListener) {
        this.scrollListener();
      }
      if (this.splineInterval) {
        clearInterval(this.splineInterval);
      }
    }
  
    private bindScrollEffect(): void {
      this.scrollListener = this.renderer.listen('window', 'scroll', () => {
        const navbar = document.querySelector('.navbar-transparent');
        if (window.scrollY > 50) {
          navbar?.classList.add('active');
        } else {
          navbar?.classList.remove('active');
        }
      });
    }
  
    private scrollToTop(): void {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  
    private setMetaTags(): void {
      this.metaTagService.addTags([
        { name: 'keywords', content: 'pixtar' },
        { name: 'robots', content: 'index, follow' },
        { name: 'author', content: 'Ipcs' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'date', content: '2022-10-1', scheme: 'YYYY-MM-DD' },
        { charset: 'UTF-8' }
      ]);
    }
  
    private hideSplineLogo(): void {
      this.splineInterval = setInterval(() => {
        const splineViewer = document.querySelector('spline-viewer');
        const shadowRoot = (splineViewer as any)?.shadowRoot;
        const logo = shadowRoot?.querySelector('#logo');
        if (logo) {
          logo.setAttribute('aria-label', 'Spline logo');
          (logo as HTMLElement).style.display = 'none';
          clearInterval(this.splineInterval);
        }
      }, 1000);
    }
  
    removeFooter(): boolean {
      const path = this.location.prepareExternalUrl(this.location.path()).slice(1);
      const noFooterRoutes = ['/signup', '/nucleoicons', 'contact', 'p/kbn', 'p/kbn2', 'p/js', 'p/io', 'p/godly'];
      return !noFooterRoutes.some(route => path.includes(route));
    }
  
    removeHeader(): boolean {
      const path = this.location.prepareExternalUrl(this.location.path()).slice(1);
      const noHeaderRoutes = ['p/kbn', 'p/kbn2', 'p/js', 'p/io', 'p/godly'];
      const hideHeader = noHeaderRoutes.includes(path);
      const botPenguinLauncher = document.getElementById('botpenguin-launcher-12');
  
      if (hideHeader && botPenguinLauncher?.classList.contains('botpenguin-right')) {
        const botChat = document.querySelector('.BotPenguin-chat');
        if (botChat) {
          botChat.classList.add('d-none');
        }
      }
  
      return !hideHeader;
    }
  }
  